import React from "react";

import { CheckboxStyled, FormControlLabelStyled } from "./check-box.styles";
import { CheckBoxProps } from "./check-box.type";

const CheckboxField = ({
  name,
  size,
  label,
  value,
  disabled,
  className,
  defaultValue,
  onChange,
  labelPlacement,
  labelWidth,
  sx,
  ...props
}) => {
  return (
    <FormControlLabelStyled
      label={label}
      name={name}
      disabled={disabled}
      labelPlacement={labelPlacement}
      labelWidth={labelWidth}
      sx={sx}
      {...props}
      control={
        <CheckboxStyled
          aria-label="switch-type"
          id={name}
          value={value}
          onChange={onChange}
          defaultChecked={defaultValue !== undefined ? defaultValue : false}
          disabled={disabled}
          checked={!!value}
          size={size ? size : "medium"}
          className={className}
          {...{
            inputProps: {
              "aria-label": typeof label === "string" ? label : "",
            },
          }}
          {...props}
        />
      }
    />
  );
};

CheckboxField.propTypes = CheckBoxProps;

export default CheckboxField;
